<template>
  <div class="notify-message" v-if="message">
    <Notice :content="message" theme="normal" leftIconType="notice"></Notice>
  </div>
</template>

<script>
import { Notice } from '@tencent/wphk-ui';
import { defineComponent } from '@vue/composition-api';
import { useNoticeMessage } from '../../store/notice-message';
import { storeToRefs } from 'pinia';

export default defineComponent({
  components: {
    Notice,
  },
  setup() {
    const { message } = storeToRefs(useNoticeMessage());
    return { message };
  },
});
</script>

<style scoped lang="less">
@rem: 200rem;

.notify-message /deep/ .top-notice {
  background: rgb(255, 245, 235);
  color: rgb(250, 157, 59);
  padding: 8/@rem 16/@rem;
  display: flex;
  border-radius: 12/@rem;
  font-size: 24/@rem;
  line-height: 32/@rem;
  font-weight: 400;
}
.notify-message /deep/ .top-notice.normal .notice-icon.notice-icon-left {
  color: rgb(250, 157, 59) !important;
  margin-right: .2em;
}
</style>
